import React, { useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import BasicTable from "../../components/UiComponent/customTable";
import { Container, Row, Button } from "react-bootstrap";
import moment from "moment";
import { useQuery } from "@tanstack/react-query";
import CustomModal from "../../components/UiComponent/Modal";
import PayrollMonthForm from "./payrollMonth";
import usePayrollApi from "../../services/payroll/payrollApi";
const MonthlyPayroll = () => {
  const { t } = useTranslation();
  const { get_payroll } = usePayrollApi();
  const [showModal, setShowModal] = useState(false);
  const currentDate = new Date();
  const formattedDate = moment(currentDate).format("YYYY-MM-DD");
  const [selectedDate, setSelectedDate] = useState(formattedDate);
  const parsedDate = moment(selectedDate, "YYYY-MM-DD");
  const getPayrollQuery = useQuery(["monthlyPayroll", parsedDate], () =>
    get_payroll(parsedDate.month() + 1, parsedDate.year())
  );
  const payrollData = useMemo(() => {
    return getPayrollQuery.data?.data?.payrolls || [];
  }, [getPayrollQuery.data]);
  if (getPayrollQuery.isLoading) {
    return <div>Loading...</div>;
  }

  if (getPayrollQuery.isError) {
    return <div>Error: {getPayrollQuery.error.message}</div>;
  }

  const handleShowModal = () => {
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };
  const payrollColumns = [
    {
      header: "full_name",
      accessorFn: (row) =>
        `${row.employee.first_name} ${row.employee.father_name} `,
    },
    {
      header: "gross",
      accessorKey: "gross",
    },
    {
      header: "taxableAllo",
      accessorKey: "taxableAllo",
    },
    {
      header: "nonTaxableAllo",
      accessorKey: "nonTaxableAllo",
    },
    {
      header: "oBenefit",
      accessorKey: "oBenefit",
    },
    {
      header: "deduction",
      accessorKey: "deduction",
    },
  ];
  return (
    <Container fluid>
      <Row>
        <BasicTable
          data={payrollData}
          columns={payrollColumns}
          title={`Monthly Payroll on ${moment(selectedDate).format(
            "MMM YYYY"
          )}`}
          actionButton={
            <div className="d-flex flex-wrap align-items-center justify-content-between">
              <input
                type="date"
                value={selectedDate}
                className="form-select form-control-sm m-2"
                onChange={(e) => {
                  const inputDate = e.target.value;
                  setSelectedDate(inputDate);
                }}
              />
              <Button
                variant="btn btn-info btn-sm m-2"
                onClick={() => handleShowModal()}
              >
                {t("prepare_payroll")}
              </Button>
            </div>
          }
        />
      </Row>
      <CustomModal
        show={showModal}
        title="Choose Payroll Month"
        onHide={handleCloseModal}
        centered={true}
        backdrop="static"
        keyboard={false}
        content={<PayrollMonthForm closeModal={handleCloseModal} />}
      />
    </Container>
  );
};

export default MonthlyPayroll;
